const faqs = [
     {
       question: "What is TEDxAjayi CrowtherU about?",
       answer:
         `TEDxAjayiCrowtherU is a TEDx event hosted by Ajayi Crowther University (ACU).  TEDxAjayiCrowtherU specifically features speakers from diverse backgrounds who present talks on various topics, aiming to inspire, inform, and spark conversations within the ACU community and beyond. These talks typically centre around the theme of "ideas worth spreading," aligning with TED's mission to foster dialogue and exchange of ideas on a global scale`,
     },
     {
       question: "Can people outside ACU attend?",
       answer:
         `Of course, TEDxAjayiCrowtherU is open to everyone, including students outside our community, great minds, including the staff are welcome to the event. All you have to do is get your ticket and attend with a positive mindset.`,
     },
     {
       question: "Do I have to pay?",
       answer:
         `Yes, you do, but be rest assured, your money will thank you for the value.`,
     },
     {
       question: "Will there be refreshments?",
       answer:
         `Yes, there will be. Your needs and comfort are our top priority. Be rest assured that you’ll be taken care of.`,
     },
     {
       question: "What do I stand to gain?",
       answer:
         `Oh, a lot! From networking, connecting with fellow attendees, speakers, and organizers who share similar interests and passions, fostering meaningful connections and potential collaborations. You'll gain insights into a wide range of topics, from technology and science to entrepreneurship and social issues, expanding your understanding and perspective. Exploring new concepts, challenging your assumptions, and broadening your horizons, fostering personal growth and development.
         
         
         Also, an opportunity to participate in your local community event that brings people together to discuss and explore ideas worth spreading, contributing to a positive impact in your school, community and beyond.`,
     },
     {
       question: "Is this the first of its kind?",
       answer:
         `No, it is not. This is the third edition of TEDxAjayiCrowtherU, following the successful events in 2019 and last year, which received rave reviews, the anticipation for this year's event is even higher. Get ready to be blown away by what we have in store for you.`,
     },
     {
       question: "Who is this event for?",
       answer:
         `TEDxAjayiCrowtherU event is typically organized for a diverse audience interested in ideas worth spreading. This audience can include people from various backgrounds, professions, and interests, including students who are curious, open-minded, and eager to engage in thought-provoking talks and discussions on a wide range of topics. TEDx events aim to inspire, inform, and spark meaningful conversations within the local community and beyond.  TEDxAjayiCrowtherU is for all innovative minds, which I believe is everyone.`,
     },
     {
       question: "What do i need to bring?",
       answer:
         `Make sure you have your ticket or registration confirmation handy for entry into the event. Come with your notebook and pen to document every key point, insight, or idea from the talks and discussions.
         Networking materials, especially if you're interested in networking with other attendees, consider bringing business cards or other materials to exchange contact information.
         Most importantly, come with an open mind and a willingness to engage with new ideas, perspectives, and experiences shared at the event.
         `,
     },
     {
       question: "Speaker: Will there be a chance to network?",
       answer:
         `Yes, there'll be provided opportunities for attendees to network with each other. During breaks, lunches, and sometimes dedicated networking sessions, attendees can engage in conversations, exchange ideas, and connect with like-minded individuals, even after the events.
         TEDxAjayiCrowtherU events have designated networking areas or activities to facilitate interactions among attendees.
         You’ll get the chance to meet people from different departments and all works of life to share your ideas and meet potential future business partners and investors. 
         `,
     },
     {
       question: "Is there a dress code?",
       answer:
         `Not really, we encourage our attendees to dress in attire that celebrates our culture and represents Africa. This can include traditional African clothing, vibrant patterns, or accessories that showcase African culture and heritage. Let's embrace the diversity and richness of our continent through our dress code.
         We can't wait to see you in your beauty and splendour.
         `,
     },
]


export default faqs